import GrowthAcquisitionExperiments from 'bundles/epic/clients/GrowthAcquisition';

const CONVERSATIONAL_ONBOARDING_EXPERIMENT_KEY = 'conversationalOnboarding' as const;

const getShouldShowModularOnboarding = () => {
  return GrowthAcquisitionExperiments.preview('showModularOnboarding');
};

/**
 * Records an impression for the conversational onboarding experiment.
 * Call when the user is actually exposed to the experiment treatment.
 *
 * @returns The variant the user is allocated to
 */
const impressIntoConversationalOnboardingExperiment = () => {
  return GrowthAcquisitionExperiments.get(CONVERSATIONAL_ONBOARDING_EXPERIMENT_KEY);
};

/**
 * Checks if the user is in either treatment variant (conversationalOnboarding or
 * fullPageUpsellAndConversationalOnboarding). Uses preview() to avoid recording an impression.
 *
 * @returns True if user is in any treatment variant (not control)
 */
const isInConversationalOnboardingVariant = (): boolean => {
  const variant = GrowthAcquisitionExperiments.preview(CONVERSATIONAL_ONBOARDING_EXPERIMENT_KEY);
  return variant !== 'control';
};

/**
 * Returns which variant the user is in without recording an impression.
 *
 * @returns Epic variant string or null
 */
const getConversationalOnboardingVariant = () => {
  return GrowthAcquisitionExperiments.preview(CONVERSATIONAL_ONBOARDING_EXPERIMENT_KEY);
};

/**
 * Checks if onboarding api should use the new learner object api.
 *
 * @returns True if should migrate to learner object api
 */
const getShouldMigrateToLearnerObject = (): boolean => {
  return GrowthAcquisitionExperiments.preview('shouldMigrateToLearnerObject');
};

const getConversationalOnboardingPollingTimeoutInMs = (): number => {
  return GrowthAcquisitionExperiments.preview('conversationalOnboardingPollingTimeoutInMs');
};

export {
  getShouldShowModularOnboarding,
  impressIntoConversationalOnboardingExperiment,
  isInConversationalOnboardingVariant,
  getConversationalOnboardingVariant,
  getShouldMigrateToLearnerObject,
  getConversationalOnboardingPollingTimeoutInMs,
};
